<template>
  <!-- 라피아캐슬 가격안내표 -->
  <div class="px-3" style="position: relative; background-color: white">
    <v-sheet v-if="loading" class="text-center py-10">
      <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
    </v-sheet>
    <table v-else class="priceGuide">
      <tr>
        <th>1인기준</th>
        <th>기본제공</th>
        <th>이용</th>
        <th>요일</th>
        <th>가격</th>
      </tr>
      <tr>
        <td rowspan="2" class="text-body-2" style="background-color: #e9e4ff">1벌</td>
        <td rowspan="2">
          드레스 / 티아라<br />목걸이 / 귀걸이<br />
          <span class="primary--text font-weight-medium">+ 셀카존 이용</span>
        </td>
        <td rowspan="2">1시간</td>
        <td>평일</td>
        <td>
          <span :class="{ 'text-decoration-line-through': isShowPromotionclothPrice, 'warning--text': isShowPromotionclothPrice }">{{
            getDispPriceWithConfig(main.clothPrice, main.clothPriceUSD)
          }}</span>
          <span v-if="isShowPromotionclothPrice"><br />{{ getDispPriceWithConfig(promotion.clothPrice, promotion.clothPriceUSD) }}</span>
        </td>
      </tr>
      <tr>
        <td>주말/공휴일</td>
        <td>
          <span :class="{ 'text-decoration-line-through': isShowPromotionclothPriceWeekend, 'warning--text': isShowPromotionclothPriceWeekend }">{{
            getDispPriceWithConfig(main.clothPriceWeekend, main.clothPriceWeekendUSD)
          }}</span>
          <span v-if="isShowPromotionclothPriceWeekend"><br />{{ getDispPriceWithConfig(promotion.clothPriceWeekend, promotion.clothPriceWeekendUSD) }}</span>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    main: Object,
    promotion: Object,
  },

  computed: {
    ...mapGetters(["isKRW"]),

    isShowPromotionclothPrice() {
      return this.promotion && this.promotion.clothPrice !== this.main.clothPrice
    },

    isShowPromotionclothPriceWeekend() {
      return this.promotion && this.promotion.clothPriceWeekend !== this.main.clothPriceWeekend
    },

    isShowPromotionunclothPrice() {
      return this.promotion && this.promotion.unclothPrice !== this.main.unclothPrice
    },

    isShowPromotionunclothPriceWeekend() {
      return this.promotion && this.promotion.unclothPriceWeekend !== this.main.unclothPriceWeekend
    },
  },

  mounted() {},
  methods: {
    getDispPriceWithConfig(krw, usd) {
      const price = this.$toComma(this.isKRW ? krw : usd)
      return this.isKRW ? `${price}원` : `${price} USD`
    },
  },
}
</script>
<style scoped>
.priceGuide {
  width: 100%;
  border: 1px solid #ccc;
  border-collapse: collapse;
  text-align: center;
  font-size: 12px;
}

.priceGuide tr th {
  padding: 4px 6px;
  border: 1px solid #ccc;
  background-color: #f7f2f7;
}

.priceGuide tr td {
  padding: 4px 6px;
  border: 1px solid #ccc;
}

.reservation {
  background: #ffe1e1;
  color: white;
}

.done {
  background: #aaaaaa;
  color: #777777;
  font-weight: 300;
}
</style>
